;(function($, g_analytics){

    'use strict';

    var rnn = window.rnn;

    function send_to_ga(socialNetwork, socialAction, socialTarget){
        var trackData = {
            tracker: 'send',
            hitType: 'social',
            socialNetwork: socialNetwork,
            socialAction: socialAction,
            socialTarget: socialTarget,
            token: 'socialEvent'
        };

        g_analytics.create_ga_event(trackData);
    }

    function registerFacebookTracking(){
        $('.facebook-share').click(function() {
            send_to_ga('facebook', 'share', window.location.href);
        });
    }

    function registerTwitterTracking(){
        $('.twitter-share').click(function() {
            send_to_ga('twitter', 'share', window.location.href);
        });
    }

    function initTrackSocial() {
        // init
        registerFacebookTracking();
        registerTwitterTracking();
    }

    rnn.modules.register('trackSocial', {
        init: initTrackSocial,
        send_to_ga: send_to_ga
    });

})(jQuery, window.rnn.modules.g_analytics);
